














































































































































































































































































































































































import { Component, Inject, Vue } from 'vue-property-decorator';
import { GridColumn } from '@/models/GridColumn.model';
import { CustomerDetailsModel } from '@/models/backoffice/CustomerDetails';
import { ManagerPrivilegesModel } from '@/models/backoffice/ManagerPrivilegesModel';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import MockData from '@/globals/mock';
import {
  ALL_OFFICES_BY_CUSTOMER,
  CREATE_MANAGER,
  CUSTOMER_DETAILS,
  DELETE_MANAGER,
  GET_ALL_OFFICES_BY_CUSTOMER,
  GET_MANAGER_PRIVILEGES,
  GET_MANAGERS_BY_CUSTOMER,
  LIST_ORG_UNITS,
  MANAGER_PRIVILEGES,
  MANAGER_TO_ADD,
  MANAGER_TO_DELETE,
  MANAGER_TO_UPDATE,
  MANAGERS_BY_CUSTOMER,
  OPEN_ADD_MANAGER_MODAL,
  OPEN_ADD_MANAGER_MODAL_ERRORS,
  OPEN_DELETE_MANAGER_MODAL,
  OPEN_DELETE_MANAGER_MODAL_ERRORS,
  OPEN_UPDATE_MANAGER_MODAL,
  OPEN_UPDATE_MANAGER_MODAL_ERRORS,
  OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL,
  OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL_ERRORS,
  ORG_UNITS,
  SEARCH_MANAGER,
  SET_MANAGER_PRIVILEGE,
  SET_MANAGER_PRIVILEGES,
  SET_MANAGER_TO_ADD,
  SET_MANAGER_TO_DELETE,
  SET_MANAGER_TO_UPDATE,
  SET_OPEN_ADD_MANAGER_MODAL,
  SET_OPEN_ADD_MANAGER_MODAL_ERRORS,
  SET_OPEN_DELETE_MANAGER_MODAL,
  SET_OPEN_DELETE_MANAGER_MODAL_ERRORS,
  SET_OPEN_UPDATE_MANAGER_MODAL,
  SET_OPEN_UPDATE_MANAGER_MODAL_ERRORS,
  SET_OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL,
  SET_ORG_UNITS,
  SET_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL_ERRORS,
  UPDATE_MANAGER,
  UPLOAD_MANAGER_PRIVILEGES_FILE,
} from '@/types/customer.types';
import { Grid } from '@/models/Grid.model';
import { ClickColumn } from '@/models/ClickColumn.model';
import { SearchManagerRequest } from '@/models/backoffice/SearchManagerRequest';
import { EmpFormsPrivilege } from '@/models/backoffice/EmpFormsPrivilege.enum';
import { OrganisationUnitModel } from '@/models/backoffice/OrganisationUnitModel';
import { OrganisationType } from '@/models/backoffice/OrganisationType.enum';
import { FieldType, SearchFieldModel } from '@/models/SearchField.model';
import {
  FORM101_UNITS_LIST_LOADING,
  GENERATE_CUBE_DETAILS_REPORT,
  GENERATE_MANAGERS_REPORT,
  MANAGER_LOADING,
  MANUAL_FORM,
} from '@/types/managerForm.types';
import { MenuAction } from '@/models/MenuAction.model';
import { RowAction } from '@/models/RowAction.model';
import { FormActions } from '@/models/form/enum/FormActions';
import { eventsHub } from '@/main';
import { INDEX_AND_OFFICES_LIST } from '@/types/lobby.types';
import { IndexAndOfficesRequest } from '@/models/request/index-and-offices-request';
import { UploadManagerPrivilegesFileModel } from '@/models/backoffice/UploadManagerPrivilegesFileModel';
import { Document } from '@/models/form/Documents.model';
import Spinner from '@/components/loading/Spinner.vue';
import { GlobalVariables } from '@/globals/global-variables';


@Component({
  components: {
    Spinner,
  },
})
export default class ManagersSettingsComponent extends Vue {

  @Inject() public $validator;

  @Action(GET_MANAGERS_BY_CUSTOMER, StoreNamespace.CUSTOMER) public getManagersByCustomer;
  @Action(GET_MANAGER_PRIVILEGES, StoreNamespace.CUSTOMER) public getManagerPrivileges;
  @Action(DELETE_MANAGER, StoreNamespace.CUSTOMER) public deleteManager;
  @Action(UPDATE_MANAGER, StoreNamespace.CUSTOMER) public updateManager;
  @Action(UPLOAD_MANAGER_PRIVILEGES_FILE, StoreNamespace.CUSTOMER) public uploadManagerPrivilegesFile;
  @Action(CREATE_MANAGER, StoreNamespace.CUSTOMER) public createManager;
  @Action(SEARCH_MANAGER, StoreNamespace.CUSTOMER) public searchManager;
  @Action(LIST_ORG_UNITS, StoreNamespace.CUSTOMER) public getOrganisationUnitsList;
  @Action(GET_ALL_OFFICES_BY_CUSTOMER, StoreNamespace.CUSTOMER) public getAllOfficesByCustomer;
  @Action(GENERATE_MANAGERS_REPORT, StoreNamespace.MANAGER) public exportManagersByCustomer;

  @Mutation(SET_MANAGER_TO_ADD, StoreNamespace.CUSTOMER) public setManagerToAdd;
  @Mutation(SET_MANAGER_TO_DELETE, StoreNamespace.CUSTOMER) public setManagerToDelete;
  @Mutation(SET_MANAGER_TO_UPDATE, StoreNamespace.CUSTOMER) public setManagerToUpdate;
  @Mutation(SET_OPEN_DELETE_MANAGER_MODAL, StoreNamespace.CUSTOMER) public setOpenDeleteManagerModal;
  @Mutation(SET_OPEN_DELETE_MANAGER_MODAL_ERRORS, StoreNamespace.CUSTOMER) public setOpenDeleteManagerModalErrors;
  @Mutation(SET_OPEN_UPDATE_MANAGER_MODAL, StoreNamespace.CUSTOMER) public setOpenUpdateManagerModal;
  @Mutation(SET_OPEN_UPDATE_MANAGER_MODAL_ERRORS, StoreNamespace.CUSTOMER) public setOpenUpdateManagerModalErrors;
  @Mutation(SET_OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL, StoreNamespace.CUSTOMER) public setOpenUploadManagerPrivilegesFileModal;
  @Mutation(SET_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL_ERRORS, StoreNamespace.CUSTOMER) public setOpenUploadManagerPrivilegesFileModalErrors;
  @Mutation(SET_OPEN_ADD_MANAGER_MODAL, StoreNamespace.CUSTOMER) public setOpenAddManagerModal;
  @Mutation(SET_OPEN_ADD_MANAGER_MODAL_ERRORS, StoreNamespace.CUSTOMER) public setOpenAddManagerModalErrors;
  @Mutation(SET_MANAGER_PRIVILEGES, StoreNamespace.CUSTOMER) public setManagerPrivileges;
  @Mutation(SET_MANAGER_PRIVILEGE, StoreNamespace.CUSTOMER) public setManagerPrivilege;
  @Mutation(SET_ORG_UNITS, StoreNamespace.CUSTOMER) public setOrgUnits;

  @Getter(CUSTOMER_DETAILS, StoreNamespace.CUSTOMER) public customerDetails!: CustomerDetailsModel;
  @Getter(MANAGERS_BY_CUSTOMER, StoreNamespace.CUSTOMER) public managersByCustomer!: Grid;
  @Getter(MANAGER_TO_ADD, StoreNamespace.CUSTOMER) public managerToAdd!: Grid;
  @Getter(MANAGER_TO_DELETE, StoreNamespace.CUSTOMER) public managerToDelete!: ManagerPrivilegesModel | null;
  @Getter(MANAGER_TO_UPDATE, StoreNamespace.CUSTOMER) public managerToUpdate!: ManagerPrivilegesModel | null;
  @Getter(OPEN_DELETE_MANAGER_MODAL, StoreNamespace.CUSTOMER) public openDeleteManagerModal!: boolean;
  @Getter(OPEN_DELETE_MANAGER_MODAL_ERRORS, StoreNamespace.CUSTOMER) public openDeleteManagerModalErrors!: string[];
  @Getter(OPEN_UPDATE_MANAGER_MODAL, StoreNamespace.CUSTOMER) public openUpdateManagerModal!: boolean;
  @Getter(OPEN_UPDATE_MANAGER_MODAL_ERRORS, StoreNamespace.CUSTOMER) public openUpdateManagerModalErrors!: string[];
  @Getter(OPEN_ADD_MANAGER_MODAL, StoreNamespace.CUSTOMER) public openAddManagerModal!: boolean;
  @Getter(OPEN_ADD_MANAGER_MODAL_ERRORS, StoreNamespace.CUSTOMER) public openAddManagerModalErrors!: string[];
  @Getter(OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL, StoreNamespace.CUSTOMER) public openUploadManagerPrivilegesFileModal!: boolean;
  @Getter(OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL_ERRORS, StoreNamespace.CUSTOMER) public openUploadManagerPrivilegesFileModalErrors!: string[];
  @Getter(ALL_OFFICES_BY_CUSTOMER, StoreNamespace.CUSTOMER) public allOfficesByCustomer!: Grid;
  @Getter(ORG_UNITS, StoreNamespace.CUSTOMER) public orgUnits!: OrganisationUnitModel[];
  @Getter(MANAGER_PRIVILEGES, StoreNamespace.CUSTOMER) public managerPrivileges!: any;
  @Getter(MANAGER_LOADING, StoreNamespace.MANAGER) public managerLoading!: boolean;
  @Getter(FORM101_UNITS_LIST_LOADING, StoreNamespace.MANAGER) public form101UnitsListLoading!: boolean;
  @Getter(MANUAL_FORM, StoreNamespace.MANAGER) public manualForms!: Document[];
  @Getter(INDEX_AND_OFFICES_LIST, StoreNamespace.AUTHENTICATION) public indexAndOfficesList!: IndexAndOfficesRequest[];
  public uploadManagerPrivilegesFileObject: UploadManagerPrivilegesFileModel = ManagersSettingsComponent.getEmptyUploadManagerPrivilegesFileObject();
  private columns: GridColumn[] = [];
  private managersMock: any = {};
  private searchManagerRequest: SearchManagerRequest = {} as SearchManagerRequest;
  private selectedOffice: number = 0;
  private selectedUnitsFrom: number = 0;
  private selectedUnitsTo: number = 0;
  private orgUnitType: OrganisationType = OrganisationType.ORG_UNIT_NUM_TYPE;
  private mockData = MockData;
  private addManagerSearchFields: SearchFieldModel[] = [];
  private addManagerColumns: GridColumn[] = [];
  private dataTableMenuActions: MenuAction[] = [];
  private uploadedFilesManagerPrivileges: Document[] = [];
  private readonly selectedOfficeIndex: number = GlobalVariables.PUBLIC_MANAGER_INDEX_NUM;

  private static getEmptyUploadManagerPrivilegesFileObject(): UploadManagerPrivilegesFileModel {
    return {
      file: null,
      indexNum: null,
      replace: false,
      type: '',
    };
  }

  public destroyed() {
    this.setOpenDeleteManagerModal(false);
    this.setOpenUpdateManagerModal(false);
    this.setOpenAddManagerModal(false);
    this.uploadedFilesManagerPrivileges = [];
  }

  public created() {
    if (this.managerPrivileges.userOrgPrivileges) {
      this.managerPrivileges.userOrgPrivileges.forEach(item => {
        item.uniqueId = '' + (Math.random() * 10000);
      });
    }
  }

  public mounted() {
    this.getManagersByCustomer(this.customerDetails.indexNum);
    this.initColumns();
    this.initDataTableMenuActions();
    this.$on('menuActionClicked', this.menuActionClicked);
  }

  private initColumns() {
    this.columns.push({
      property: 'indexNum',
      header: 'back_office.settings.managers.indexNum',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'userId',
      header: 'back_office.settings.managers.userId',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'managerName',
      header: 'back_office.settings.managers.managerName',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'empFormsPrivDesc',
      header: 'back_office.settings.managers.empFormsPriv',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'cubesFormFlag',
      header: 'back_office.settings.managers.cubesFormFlag',
      hideSorting: true,
      booleanProperty: true,
      trueValue: '' + this.$t('back_office.settings.managers.yes'),
      falseValue: '' + this.$t('back_office.settings.managers.no'),
    } as GridColumn);
    this.columns.push({
      clickEvent: 'DELETE',
      mdIcon: 'delete',
      header: 'back_office.settings.reminders.delete',
    } as ClickColumn);
  }

  private initAddManagerColumns() {
    this.addManagerColumns = [];
    this.addManagerColumns.push({
      property: 'officeNum',
      header: 'employees_list.officeNum',
      hideSorting: true,
    } as GridColumn);
    this.addManagerColumns.push({
      property: 'userId',
      header: 'back_office.settings.managers.userId',
      hideSorting: true,
    } as GridColumn);
    this.addManagerColumns.push({
      property: 'idNumber',
      header: 'employees_list.idNumber',
      hideSorting: true,
    } as GridColumn);
    this.addManagerColumns.push({
      property: 'fullName',
      header: 'back_office.settings.managers.managerName',
      hideSorting: true,
    } as GridColumn);
    this.addManagerColumns.push({
      clickEvent: 'ADD',
      mdIcon: 'add',
      header: 'back_office.settings.managers.add',
    } as ClickColumn);
  }

  private initAddManagerSearchObject() {
    this.addManagerSearchFields = [];
    this.addManagerSearchFields.push({
      label: 'employees_list.idNumber',
      property: 'userId',
      fieldType: FieldType.TEXT_FIELD,
      isRequired: true,
    });
  }

  private initDataTableMenuActions() {
    this.dataTableMenuActions.push({
      name: 'FORM_SEARCH_EXPORT_EXCEL', faIconType: 'fal', faIconName: 'file-excel', event: 'EXPORT_EXCEL',
    } as MenuAction);
    this.dataTableMenuActions.push({
      name: 'UPLOAD_MANAGER_PRIVILEGES', faIconType: 'fa', faIconName: 'file-csv', event: 'UPLOAD_MANAGER_PRIVILEGES',
    } as MenuAction);
    this.dataTableMenuActions.push({
      name: 'UPLOAD_MANAGER_PRIVILEGES_UNIT',
      faIconType: 'fa',
      faIconName: 'file-csv',
      event: 'UPLOAD_MANAGER_PRIVILEGES_UNIT',
    } as MenuAction);
  }

  private onRowClicked(item) {
    this.selectedOffice = 0;
    this.setManagerToUpdate(item);
    this.getManagerPrivileges(item);
    this.setOpenUpdateManagerModalErrors({});
    // this.setOpenUpdateManagerModal(true);
  }

  private onTdClicked(item, column) {
    switch (column.clickEvent) {
      case 'DELETE':
        this.setManagerToDelete(item);
        this.setOpenDeleteManagerModal(true);
        break;
    }
  }

  private onAddManagerTdClicked(item, column) {
    switch (column.clickEvent) {
      case 'ADD':
        this.onAddingManager(item);
        break;
    }
  }

  private addManager() {
    this.setManagerToAdd({} as Grid);
    this.setOpenAddManagerModal(true);
    this.setOpenAddManagerModalErrors([]);
    this.initAddManagerColumns();
    this.initAddManagerSearchObject();
    this.searchManagerRequest = {} as SearchManagerRequest;
  }

  private closeAddModal() {
    this.setOpenAddManagerModal(false);
  }

  private onSearch(searchObject) {
    searchObject.indexNum = this.customerDetails.indexNum;
    this.searchManager(searchObject);
  }

  private onClear() {
    this.setManagerToAdd({} as Grid);
  }

  private menuActionClicked(action: RowAction, selectedRows: any[]) {
    switch (action.name) {
      case FormActions.FORM_SEARCH_EXPORT_EXCEL:
        this.exportManagersByCustomer(this.customerDetails.indexNum);
        break;
      case FormActions.UPLOAD_MANAGER_PRIVILEGES:
        this.uploadManagerPrivilegesFileObject.type = action.name;
        this.setOpenUploadManagerPrivilegesFileModal(true);
        break;
      case FormActions.UPLOAD_MANAGER_PRIVILEGES_UNIT:
        this.uploadManagerPrivilegesFileObject.type = action.name;
        this.setOpenUploadManagerPrivilegesFileModal(true);
        break;
    }
  }

  private onUploadClicked(file): void {
    this.onRemoveUploadedFile();
    this.uploadedFilesManagerPrivileges.push(file);
    this.uploadManagerPrivilegesFileObject.file = file;
  }

  private onRemoveUploadedFile(): void {
    this.uploadedFilesManagerPrivileges = [];
    this.uploadManagerPrivilegesFileObject.file = null;
  }

  private onSearchManager() {
    this.$validator.validateAll('searchManagerForm').then((valid: boolean) => {
      if (valid) {
        this.searchManagerRequest.indexNum = this.customerDetails.indexNum;
        this.searchManager(this.searchManagerRequest);
      }
    });
  }

  private onAddingManager(managerToAdd) {
    this.$validator.validateAll('payrollCustomerSettings').then((result: any) => {
      if (!result) {
        setTimeout(() => {
          const firstInput: HTMLElement = document.querySelectorAll('label.is-error')[0] as HTMLElement;
          if (firstInput) {
            firstInput.focus();
          }
        });
      } else {
        managerToAdd.empFormsPriv = EmpFormsPrivilege.MANAGER_VIEW_ONLY;
        managerToAdd.cubesFormFlag = false;
        this.createManager(managerToAdd);
      }
    });
  }

  private closeDeleteModal() {
    this.setOpenDeleteManagerModal(false);
    this.setManagerToDelete(null);
  }

  private onRemovedClicked() {
    if (this.managerToDelete) {
      this.deleteManager(this.managerToDelete);
    }
  }

  private closeUpdateModal() {
    this.setOpenUpdateManagerModal(false);
    this.setManagerToUpdate(null);
    if (this.orgUnits.length) {
      this.setOrgUnits(undefined);
    }
  }

  private closeUploadModal() {
    this.setOpenUploadManagerPrivilegesFileModal(false);
    this.setOpenUploadManagerPrivilegesFileModalErrors([]);
    this.uploadManagerPrivilegesFileObject = ManagersSettingsComponent.getEmptyUploadManagerPrivilegesFileObject();
    this.uploadedFilesManagerPrivileges = [];
  }

  private onUploadManagerPrivilegesClicked() {
    this.$validator.validateAll('payrollUploadManagerPrivilegesFile').then((result: any) => {
      if (!result) {
        setTimeout(() => {
          const firstInput: HTMLElement = document.querySelectorAll('label.is-error')[0] as HTMLElement;
          if (firstInput) {
            firstInput.focus();
          }
        });
      } else {
        this.setOpenUploadManagerPrivilegesFileModalErrors([]);
        this.uploadManagerPrivilegesFileObject.indexNum = this.customerDetails.indexNum;
        this.uploadManagerPrivilegesFile({
          requestBody: this.uploadManagerPrivilegesFileObject,
        });
      }
    });
  }

  private onUpdateClicked() {
    if (this.managerToUpdate) {
      if (!this.managerPrivileges.userOrgPrivileges || !this.managerPrivileges.userOrgPrivileges.length) {
        this.updateManagerPrivileges([], 'userOrgPrivileges');
      }
      this.updateManager();
    }
  }

  private addChild() {
    if (!this.managerPrivileges.userOrgPrivileges || !this.managerPrivileges.userOrgPrivileges.length) {
      this.updateManagerPrivileges([], 'userOrgPrivileges');
    }
    this.setManagerPrivileges({
      ...this.managerPrivileges,
      userOrgPrivileges: [...this.managerPrivileges.userOrgPrivileges,
        { allUnitsPrivileges: true, orgUnitType: 4, officeNum: this.allOfficesByCustomer.results[0].officeNum }],
    });
    const childrenElement: HTMLElement | null = document.getElementById('cardChildrenListInner');
    if (childrenElement) {
      setTimeout(() => {
        childrenElement.scrollTop = childrenElement.scrollHeight;
        // childrenElement.animate({ scrollTop: $('#cardChildrenListInner').prop("scrollHeight") }, 800);
        // childrenElement.scrollIntoView({behavior: "smooth", block: "end"});
      }, 100);
    }
  }

  private deletePrivilege(i: number) {
    const updatedPrivilege = [...this.managerPrivileges.userOrgPrivileges];
    updatedPrivilege.splice(i, 1);
    this.setManagerPrivileges({
      ...this.managerPrivileges,
      userOrgPrivileges: updatedPrivilege,
    });
  }

  private onSelectOffice(item: any, i: number) {
    this.setManagerPrivilege({ value: item, property: 'officeNum', index: i });
    if (!this.managerPrivileges.userOrgPrivileges[i].allUnitsPrivileges) {
      this.getOrganisationUnitsList({
        index: i,
        officeNum: item,
        indexNum: this.customerDetails.indexNum,
        orgUnitType: this.managerPrivileges.userOrgPrivileges[i].orgUnitType,
      });
    }
  }

  private onSelectType(item: any, i: number) {
    this.setManagerPrivilege({ value: item, property: 'orgUnitType', index: i });
    if (!this.managerPrivileges.userOrgPrivileges[i].allUnitsPrivileges
        || this.managerPrivileges.userOrgPrivileges[i].officeNum) {
      this.setOrgUnits({});
      this.getOrganisationUnitsList({
        index: i,
        officeNum: this.managerPrivileges.userOrgPrivileges[i].officeNum,
        indexNum: this.customerDetails.indexNum,
        orgUnitType: item,
      });
      // this.setManagerPrivilege({ value: undefined, property: 'orgUnitFrom', index: i });
      // this.setManagerPrivilege({ value: undefined, property: 'orgUnitTo', index: i });
    }

  }

  private onAllUnitsPrivilegesSelect(item: any, i: number) {
    this.setManagerPrivilege({ value: item, property: 'allUnitsPrivileges', index: i });
    if (!item) {
      this.getOrganisationUnitsList({
        index: i,
        officeNum: this.managerPrivileges.userOrgPrivileges[i].officeNum,
        indexNum: this.customerDetails.indexNum,
        orgUnitType: this.managerPrivileges.userOrgPrivileges[i].orgUnitType,
      });
    }
  }

  private updateManagerPrivileges(newVal: any, property: string) {
    this.setManagerPrivileges({ ...this.managerPrivileges, [property]: newVal });
  }

}

